import {
  useEffect,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Box,
  Center,
  Image,
  Skeleton,
  Spinner,
  Text,
  useDisclosure
} from '@chakra-ui/react'
import { ImagesPng } from 'assets/images'
import {
  eventSeenAll,
  getEventData,
  getNotificationMessage,
  getSavedEvents,
  postMakeNotificationSeen,
  postMakeNotificationSeenAll,
  setEventData,
  setEventId,
  setNotificationSectionPage,
  setProfileItemId,
  setSavedEvents,
  setSelectedEventData,
  setGetSavedEventsStatus,
  setOpenBlogLink,
  showCurrentChatFriendMarkerCoordinate,
  usersSelectors,
  singleMarkerUpdate,
  markersSelectors,
  modifyAdminNotifications
} from 'store'
import {
  NotificationSections,
  PENDING,
  REJECTED,
  SUCCEEDED
} from 'utils/constants'
import { RotatingAffinityText } from 'common/Buttons'
import { convertToOwnTimeZone } from 'utils/helpers'
import { COLORS } from 'utils/styles'

import { ContentModal } from '../ContentModal'

export const ContentItem = ({
  items,
  title,
  selectedKey,
  setSelectedKey
}) => {
  const {
    eventMarkers,
    getEventDataStatus,
    markers,
    singleMarkerUpdateStatus
  } = useSelector(markersSelectors)
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [selectedItem, setSelectedItem] = useState({})
  const [isNotifModalOpen, setIsNotifModalOpen] = useState(false)
  const [loadedNotifImage, setLoadedNotifImage] = useState({})
  const {
    filters,
    getBlogPreferenceStatus,
    getPostsStatus,
    getEngagementItemsStatus,
    getProfileItemStatus,
    getBlockedRequestStatus,
    getFriendsNotificationsStatus,
    getSavedEventsStatus,
    postMakeNotificationSeenAllStatus,
    userProfile
  } = useSelector(usersSelectors)

  const dispatch = useDispatch()

  const handleNotifImage = (typeAndId) => {
    setLoadedNotifImage((prev) => ({
      ...prev,
      [typeAndId]: true
    }))
  }

  const handleOpenModal = (item) => {
    setIsNotifModalOpen(true)
    onOpen()
    setSelectedItem(item)
  }

  const handleCloseModal = () => {
    onClose()
    setIsNotifModalOpen(false)
    sessionStorage.removeItem('id')
    localStorage.setItem('is-notif-modal-open', 'false')
  }

  const GoToMarker = (item) => {
    document.querySelector('#back-button').click()
    dispatch(setProfileItemId(''))

    setTimeout(() => {
      dispatch(showCurrentChatFriendMarkerCoordinate({
        coord: item?.description?.coordinates,
        isStatic: true
      }))
      sessionStorage.setItem('openProfileAfterAnimation', item?.description?.profile_id)
    }, 1050)
  }

  const goToEdit = (item) => {
    dispatch(eventSeenAll())
    document.querySelector('#back-button').click()
    dispatch(setEventId(null))
    dispatch(setSelectedEventData(null))

    setTimeout(() => {
      dispatch(showCurrentChatFriendMarkerCoordinate({
        coord: [item?.lat, item?.lng],
        isStatic: true
      }))
      sessionStorage.setItem('openEventAfterAnimation', item?.id)
    }, 1050)
  }

  const isClickable = () => {
    if (
      getPostsStatus === PENDING
      || postMakeNotificationSeenAllStatus === PENDING
      || getProfileItemStatus === PENDING
      || getEventDataStatus === PENDING
      || getEngagementItemsStatus === PENDING
      || getBlogPreferenceStatus === PENDING
      || singleMarkerUpdateStatus === PENDING
      || getSavedEventsStatus === PENDING
      || sessionStorage.getItem('openProfileAfterAnimation')
      || sessionStorage.getItem('openEventAfterAnimation')
    ) {
      return 'none'
    }

    return 'auto'
  }

  const isFaded = () => {
    if (
      getPostsStatus === PENDING
      || postMakeNotificationSeenAllStatus === PENDING
      || getProfileItemStatus === PENDING
      || getEventDataStatus === PENDING
      || getEngagementItemsStatus === PENDING
      || getBlogPreferenceStatus === PENDING
      || singleMarkerUpdateStatus === PENDING
      || getSavedEventsStatus === PENDING
      || sessionStorage.getItem('openProfileAfterAnimation')
      || sessionStorage.getItem('openEventAfterAnimation')
    ) {
      return '0.7'
    }

    return '1'
  }

  const handleFiltersInfo = () => {
    let codewordFilterCount = 0
    let affinityFilterCount = 0
    let ownFilterCount = 0
    let filterAffinityList = []

    filters?.forEach((f) => {
      if (f?.type === 'affinities') {
        affinityFilterCount += 1
        filterAffinityList.push(f?.title)
      } else if (f?.type === 'code_word') {
        codewordFilterCount += 1
      } else {
        ownFilterCount += 1
      }
    })

    return {
      codewordFilterCount,
      affinityFilterCount,
      ownFilterCount,
      filterAffinityList
    }
  }

  const notificationListClick = async (item) => {
    if (
      (
        item.related_to === '5 new profile'
        || item.related_to === 'profile new affinity'
      )
      && getProfileItemStatus !== 'PENDING'
      && getBlockedRequestStatus !== 'PENDING'
      && getFriendsNotificationsStatus !== 'PENDING'
    ) {
      if (!item?.is_viewed) {
        if (item.related_to === '5 new profile') {
          const idList = []

          items.forEach((data) => idList.push(data.id))
          dispatch(postMakeNotificationSeenAll({
            idList,
            id: item.id
          }))
        } else {
          dispatch(postMakeNotificationSeen({
            notificationId: item?.id,
            title
          }))
        }
      }

      let result = []
      result = await dispatch(singleMarkerUpdate(item?.description?.profile_id))

      if (
        markers.find((marker) => marker.id === item?.description?.profile_id)
        || userProfile.find((profile) => profile.id === item?.description?.profile_id)
        || result?.payload?.length
      ) {
        const filtersInfo = handleFiltersInfo()
        let affinityMatchCount = 0

        if (
          !filtersInfo.ownFilterCount
          && !filtersInfo.codewordFilterCount
          && filtersInfo.affinityFilterCount
        ) {
          result?.payload[0]?.affinities.forEach((profileAffi) => {
            if (filtersInfo.filterAffinityList.includes(profileAffi)) {
              affinityMatchCount += 1
            }
          })
        }

        if (
          !filtersInfo.ownFilterCount
          && !filtersInfo.codewordFilterCount
          && filtersInfo.affinityFilterCount === affinityMatchCount
        ) {
          GoToMarker(item)
        } else {
          dispatch(
            getNotificationMessage({
              type: REJECTED,
              message: 'The marker filter hides this profile',
              isEditProfile: false
            })
          )
        }
      } else {
        dispatch(modifyAdminNotifications({
          type: title,
          id: item?.id
        }))

        dispatch(
          getNotificationMessage({
            type: REJECTED,
            message: 'The profile is unavailable',
            isEditProfile: false
          })
        )
      }
    } else if (
      item?.type === 'real_event'
      && getProfileItemStatus !== 'PENDING'
      && getBlockedRequestStatus !== 'PENDING'
      && getFriendsNotificationsStatus !== 'PENDING'
    ) {
      dispatch(setEventData())
      let result = []
      result = await dispatch(getEventData(item?.id))

      if (
        (
          eventMarkers?.find((eventMarker) => eventMarker.id === item?.id)
          && result?.payload?.id
        )
        || result?.payload?.id === item?.id
      ) {
        const filtersInfo = handleFiltersInfo()
        let affinityMatchCount = 0

        if (
          !filtersInfo.ownFilterCount
          && !filtersInfo.codewordFilterCount
          && filtersInfo.affinityFilterCount
        ) {
          if (filtersInfo.filterAffinityList.includes(result?.payload?.affinities)) {
            affinityMatchCount += 1
          }
        }

        if (
          !filtersInfo.ownFilterCount
          && !filtersInfo.codewordFilterCount
          && filtersInfo.affinityFilterCount === affinityMatchCount
        ) {
          goToEdit(result.payload)
        } else {
          dispatch(
            getNotificationMessage({
              type: REJECTED,
              message: 'The marker filter hides this event',
              isEditProfile: false
            })
          )
        }
      } else {
        dispatch(modifyAdminNotifications({
          type: title,
          id: item?.id
        }))

        dispatch(
          getNotificationMessage({
            type: REJECTED,
            message: 'The event is unavailable',
            isEditProfile: false
          })
        )
      }
    } else if (getProfileItemStatus === 'PENDING') {
      console.log('stop')
    } else {
      if (title === 'connector' && item?.link) {
        dispatch(setOpenBlogLink(item?.link + '?autoplay=1'))
      } else {
        handleOpenModal(item)
      }

      if (!item?.is_viewed) {
        dispatch(postMakeNotificationSeen({
          notificationId: item?.id,
          title
        }))
      }
    }
    localStorage.setItem('is-notif-modal-open', 'true')
  }

  window.addEventListener('beforeunload', () => {
    localStorage.setItem('is-notif-modal-open', 'false')
  })

  useEffect(() => {
    if (getSavedEventsStatus === SUCCEEDED) {
      dispatch(setNotificationSectionPage({
        key: NotificationSections.SAVED_EVENTS_LIST,
        title: 'Saved Events'
      }))

      dispatch(setGetSavedEventsStatus(0))
    }
  }, [getSavedEventsStatus])

  if (!items.length) {
    return <div>No notifications to display</div>
  }

  return (
    <>
      {[...items].reverse().map((item) => (
        <Box
          key={title + item.id}
          cursor="pointer"
          display={
            item?.type === 'real_event'
            && convertToOwnTimeZone(item?.end_date, 'newDate') <= new Date()
              ? 'none'
              : 'flex'
          }
          onClick={() => {
            let waitTime = 0
            if (
              document.querySelector('#blog-panel')
              || document.querySelector('#event-popup')
            ) {
              document.querySelector('#force-close-blog-panel')?.click()
              document.querySelector('#force-close-event-panel')?.click()
              waitTime = 900
              setSelectedItem(item)
              setSelectedKey(null)
            }

            setTimeout(() => {
              if (item?.type === 'saved_events') {
                setSelectedKey(title + item.id)
                dispatch(setSavedEvents([]))
                dispatch(getSavedEvents({
                  limit: Math.ceil(window.innerHeight / 90)
                }))
              } else {
                setSelectedKey(title + item.id)
                notificationListClick(item)
              }
            }, waitTime)
          }}
          onLoad={() => {
            if (localStorage.getItem('openedNotifId') === String(item?.id)) {
              localStorage.removeItem('openedNotifId')

              if (
                item.related_to !== '5 new profile'
                && item.related_to !== 'profile new affinity'
              ) {
                handleOpenModal(item)
              }
            }
          }}
          marginTop="3px"
          minWidth="108px"
          data-name="notificationItem"
          pointerEvents={isClickable()}
          position="relative"
        >
          <Skeleton
            isLoaded={loadedNotifImage[title + item.id]}
            borderRadius="5px"
          >
            <Box
              border={item?.type === 'real_event' || item?.type === 'saved_events' ? 'solid 1px black' : ''}
              width="110px"
              height="110px"
              borderRadius="5px"
              overflow="hidden"
              gap="0"
              margin="0"
              position="relative"
            >
              <Image
                width="110px"
                height="110px"
                objectFit="cover"
                src={item?.image || ImagesPng.DefaultImage}
                alt={item?.title}
                opacity={isFaded()}
                onLoad={() => handleNotifImage(title + item.id)}
                {...(item?.type === 'real_event' ? { filter: 'blur(1px)' } : {})}
                {...(item?.type === 'saved_events' ? {
                  filter: 'blur(2px)',
                  backgroundColor: 'rgba(255,255,255,0.8)'
                } : {})}
              />

              {
                selectedKey === (title + item.id)
                && (
                  postMakeNotificationSeenAllStatus === PENDING
                  || getEventDataStatus === PENDING
                  || singleMarkerUpdateStatus === PENDING
                  || getSavedEventsStatus === PENDING
                  || sessionStorage.getItem('openProfileAfterAnimation')
                  || sessionStorage.getItem('openEventAfterAnimation')
                )
                  ? (
                    <Center
                      position="absolute"
                      top="2.5"
                      left="50%"
                      transform="translateX(-50%)"
                      zIndex="10"
                    >
                      <Spinner
                        width="80px"
                        height="80px"
                        position="sticky"
                        zIndex={5}
                      />
                    </Center>
                  ) : ''
              }

              {
                item?.type === 'saved_events'
                  ? (
                    <Text
                      position="absolute"
                      top="5"
                      width="110px"
                      padding="0 5px"
                      textAlign="center"
                      fontSize="33px"
                      wordBreak="break-word"
                      lineHeight="35px"
                      textShadow={
                        '1px 0 0 white, -1px 0 0 white, 0 1px 0 white, 0 -1px 0 white, '
                        + '1px 1px 0 white, -1px 1px 0 white, 1px -1px 0 white, -1px -1px 0 white, '
                        + '0 4px 5px rgba(0,0,0,1)'
                      }
                    >
                      {item?.title}
                    </Text>
                  )
                  : ''
              }

              {
                item?.type === 'real_event'
                  ? (
                    <>
                      <Text
                        position="absolute"
                        top="1px"
                        width="110px"
                        padding="0 5px"
                        textAlign="center"
                        fontSize="14px"
                        textOverflow="ellipsis"
                        whiteSpace="nowrap"
                        overflow="hidden"
                        textShadow={
                          '1px 0 0 white, -1px 0 0 white, 0 1px 0 white, 0 -1px 0 white, '
                          + '1px 1px 0 white, -1px 1px 0 white, 1px -1px 0 white, -1px -1px 0 white'
                        }
                      >
                        {item?.title}
                      </Text>

                      <Text
                        position="absolute"
                        top="45px"
                        width="110px"
                        textAlign="center"
                        fontSize="14px"
                        textShadow={
                          '1px 0 0 white, -1px 0 0 white, 0 1px 0 white, 0 -1px 0 white, '
                          + '1px 1px 0 white, -1px 1px 0 white, 1px -1px 0 white, -1px -1px 0 white'
                        }
                      >
                        {convertToOwnTimeZone(item?.start_date, 'Y.m.d')}
                      </Text>

                      <RotatingAffinityText
                        key={item?.id + item?.type}
                        affinities={item?.affinities}
                        style={{
                          fontSize: '14px',
                          borderRadius: '5px',
                          border: 'solid 1px black',
                          textAlign: 'center',
                          letterSpacing: '-1px',
                          position: 'absolute',
                          bottom: '1',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          width: '80%',
                          paddingLeft: '5px',
                          paddingRight: '5px',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden'
                        }}
                      />
                    </>
                  )
                  : ''
              }

              {
                item.related_to === '5 new profile'
                  ? (
                    <Text
                      position="absolute"
                      bottom="0"
                      padding="2px"
                      fontSize="14px"
                      color={COLORS.white}
                      textShadow={
                        '1.3px 0 0 black, -1.3px 0 0 black, 0 1.3px 0 black, 0 -1.3px 0 black, '
                        + '1.3px 1.3px 0 black, -1.3px 1.3px 0 black, 1.3px -1.3px 0 black, -1.3px -1.3px 0 black'
                      }
                      lineHeight="20px"
                      textAlign="center"
                      width="108px"
                      noOfLines={2}
                      pointerEvents="none"
                    >
                      {item.title}
                    </Text>
                  )
                  : ''
              }
            </Box>
          </Skeleton>
        </Box>
      ))}

      <ContentModal
        item={selectedItem}
        onClose={handleCloseModal}
        isNotifModalOpen={isNotifModalOpen}
        isOpen={isOpen}
        title={title}
        setSelectedItem={setSelectedItem}
      />
    </>
  )
}
